export default {
  // area: '通讯录',
  // objectName: '',
  //url
  // http://192.168.1.20:8087
  // http://19 2.168.1.20:8066/
  // hostUrl: 'https://yyjp.zhsq.cloud',
  // apiHttpsUrl: 'http://192.168.1.20:8087',
  // apiRequestUrl: 'http://192.168.1.20:8087',
  // apiUploadUrl: 'http://192.168.1.20:8087/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168.1.20:8087/api/UploadFile/UploadImgOrFile',
  // apiUploadvideo: 'http://192.168.1.20:8087/api/UploadFile/UploadQiniuVideo',

  hostUrl: 'https://yyjp.zhsq.cloud',
  apiHttpsUrl: 'https://mall.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://mall.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://mall.anluoyun.cn/common/OssUploadImg',
  apiUploadFiles: 'https://mall.anluoyun.cn/api/UploadFile/UploadImgOrFile',
  apiUploadvideo: 'https://mall.anluoyun.cn/api/UploadFile/UploadQiniuVideo',
}
